export const resizeWindow = (width: number) => {
    global.innerWidth = width;
    global.dispatchEvent(new Event("resize"));
};
